import { backendRequest } from 'services/request'

export function getCurrentUser() {
  return backendRequest({
    url: '/users/me',
    method: 'get'
  })
}

export function syncUser () {
  return backendRequest({
    url: '/users/sync',
    method: 'post'
  })
}